import { linkClasses } from '@planne-software/uni';
import { Box, Stack, styled, type SxProps, type Theme } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { uniTypography } from '@src/fonts/typography/uniTypography';

export const authLinkSx: SxProps<Theme> = {
  cursor: 'pointer',
  fontSize: uni('typography-font-size-text-sm'),
  fontWeight: uni('typography-font-weight-semibold'),
  lineHeight: uni('typography-line-height-text-sm'),
  textUnderlinePosition: 'from-font',
  [`&.${linkClasses.disabled}`]: {
    cursor: 'not-allowed',
  },
};

export const RecoveryLinkRow = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: uni('scale-100'),
}));

export const RecoveryLinkPrefix = styled('span')`
  ${uniTypography('text-sm', 'regular')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
`;

export const OtpResendRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
}));

export const OtpTimerText = styled('p')`
  ${uniTypography('text-xs', 'regular')}
  color: ${uni('fg-neutral-static-default-caption')};
  margin: 0;
`;

export const SignupLinkWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
}));

export const ButtonGroup = styled(Stack)(() => ({
  gap: uni('scale-200'),
  width: '100%',
  alignItems: 'center',
}));

export const PasswordSuffixButton = styled('button')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: ${uni('scale-250')};
  cursor: pointer;
  color: ${uni('fg-neutral-action-default-rest')};
`;
